import LinkedAccountNewTemplate from '@/features/agent/linked_accounts/templates/LinkedAccountNewTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/linked_accounts/new/')({
  component: LinkedAccountNew,
  staticData: { title: '連携先追加' },
});

function LinkedAccountNew() {
  return <LinkedAccountNewTemplate />;
}
